import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import step1 from "../../assets/icon/step1.svg";
import step2 from "../../assets/icon/step2.svg";
import step3 from "../../assets/icon/step3.svg";
import step4 from "../../assets/icon/step4.svg";
import step5 from "../../assets/icon/step5.svg";
import step6 from "../../assets/icon/step6.svg";
import PopupLoginError from "../../components/Popup/LoginError";
import instance from "../../services/services";
import { INSTRUCTION_DATA_URL } from "../../utils/urls";
import { useLanguage } from "../../hooks/useLanguage";


function UsageInformation(){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('visit');
  const [isPopupLoginError, setIsPopupLoginError] = useState(false);
  const [instructionData, setInstructionData] = useState([]);

  const handleActiveTab = (tab) =>{
    setActiveTab(tab);
  };

  useEffect(()=> {
    const fetchInstructionData = async () => {
      try {
        const response = await instance.post(INSTRUCTION_DATA_URL);
        setInstructionData(response.data.data.data);
      } catch (error) {
        console.error('이용안내 데이터 가져오기 실패:', error);
      }
    };
    fetchInstructionData();
  }, []);

  const handleConfirm = () => {
    navigate('/login');
  };

  return(
    <section className="guide_section">
      <h3 className="commu_title noline">{t('usage_guide')}</h3>

      {/* 탭 */}
      <div className="wish_tabs mb_24">
        <div
          className={`w_tab ${activeTab ==='visit' ?  'active' : ''}`}
          onClick={()=> handleActiveTab('visit')}
        >
          {t('in_store_order')}
        </div>
        <div
          className={`w_tab ${activeTab ==='parcel' ?  'active' : ''}`}
          onClick={()=> handleActiveTab('parcel')}
        >
          {t('delivery_order')}
        </div>
      </div>

      {/* 매장방문주문 */}
      {activeTab === 'visit' ? (
        <div className="visit_tab_con apply_guide">
          <h4>{t('in_store_order')}</h4>
          <ul className="benefit_info_list step_box">
            <li className="step_con">
              <span className="blue strong_b3">STEP 1</span>
              <div className="step_btm">
                <img src={step1} alt="step1" loading="lazy"/>
                <p>{t('equipment_selection')}</p>
                <span className="g-80">
                  {t('sign_up_1')}<br/>
                  {t('search_equipment_1')}
                </span>
              </div>
            </li>
            <li className="step_con">
              <span className="blue strong_b3">STEP 2</span>
              <div className="step_btm">
                <img src={step2} alt="step2" loading="lazy"/>
                <p>{t('equipment_order')}</p>
                <span className="g-80">
                  {t('add_to_cart3')}<br/>
                  {t('delivery_order_0')}
                </span>
              </div>
            </li>
            {/* <li className="step_con">
              <span className="blue strong_b3">STEP 3</span>
              <div className="step_btm">
                <img src={step4} alt="step4" loading="lazy"/>
                <p>{t('equipment_shipping22')}</p>
                <span className="g-80">
                  {t('receive_equipment2')}<br/>
                  {t('equipment_received')}
                </span>
              </div>
            </li> */}
            <li className="step_con">
              <span className="blue strong_b3">STEP 3</span>
              <div className="step_btm">
                <img src={step5} alt="step5" loading="lazy"/>
                <p>{t('equipment_received')}</p>
                <span className="g-80">
                  {t('visit_store_test_equipment')}<br/>
                  {t('visit_store_test_equipment_1')}
                </span>
              </div>
            </li>
            <li className="step_con">
              <span className="blue strong_b3">STEP 4</span>
              <div className="step_btm">
                <img src={step6} alt="step6 " loading="lazy"/>
                <p>{t('equipment_returned')}</p>
                <span className="g-80">
                  {t('visit_store_test_equipment_0')}<br/>
                  {t('equipment_returned')}
                </span>
              </div>
            </li>
          </ul>
        </div>
      ) : (
          // 택배수령주문
        <div>
          <div className="visit_tab_con apply_guide">
            <h4>{t('delivery_order')}</h4>
            <ul className="benefit_info_list step_box">
              <li className="step_con">
                <span className="blue strong_b3">STEP 1</span>
                <div className="step_btm">
                  <img src={step1} alt="step1" loading="lazy"/>
                  <p>{t('equipment_selection')}</p>
                  <span className="g-80">
                    {t('sign_up_1')}<br/>
                    {t('search_equipment_1')}
                  </span>
                </div>
              </li>
              <li className="step_con">
                <span className="blue strong_b3">STEP 2</span>
                <div className="step_btm">
                  <img src={step2} alt="step2" loading="lazy"/>
                  <p>{t('equipment_order')}</p>
                  <span className="g-80">
                    {t('add_to_cart3')}<br/>
                    {t('delivery_order_1')}
                  </span>
                </div>
              </li>
              <li className="step_con">
                <span className="blue strong_b3">STEP 3</span>
                <div className="step_btm">
                  <img src={step3} alt="step1" loading="lazy"/>
                  <p>{t('equipment_shipping22')}</p>
                  <span className="g-80">
                    {t('equipment_preparation')}<br/>
                    {t('equipment_shipping29')}
                  </span>
                </div>
              </li>
              <li className="step_con">
                <span className="blue strong_b3">STEP 4</span>
                <div className="step_btm">
                  <img src={step4} alt="step4" loading="lazy"/>
                  <p>{t('equipment_received')}</p>
                  <span className="g-80">
                    {t('equipment_shipping25')}<br/>
                    ({t('free_1')})
                  </span>
                </div>
              </li>
              <li className="step_con">
                <span className="blue strong_b3">STEP 5</span>
                <div className="step_btm">
                  <img src={step5} alt="step5" loading="lazy"/>
                  <p>{t('equipment_rented')}</p>
                  <span className="g-80">
                    {t('equipment_rental_start_date2')}<br/>
                    {t('rental_fee_payment2')}
                  </span>
                </div>
              </li>
              <li className="step_con">
                <span className="blue strong_b3">STEP 6</span>
                <div className="step_btm">
                  <img src={step6} alt="step6" loading="lazy"/>
                  <p>{t('equipment_returned')}</p>
                  <span className="g-80">
                    {t('equipment_shipping27')}<br/>
                    {t('free_2')}
                  </span>
                </div>
              </li>

            </ul>
          </div>
          <div className="apply_guide mt_32 use_font">
            <h4>{t('equipment_shipping2')}</h4>

            <div className="parcel_info">

              <div className="con_box">
                <div className="con_top">
                  <div className="flex-center-2 column">
                    <p className="p3">{t('order_date2')}</p>
                    <span className="g-90 b3_2">{t('equipment_selection_and_order2')}</span>
                  </div>
                </div>
                <div className="con_btm">
                  <p className="b1_1">{t('free_1')}</p>
                </div>
              </div>

              <div className="con_box">
                <div className="con_top">
                  <div className="flex-center-2 column">
                    <p className="p3">{t('shipping_in_progress')}</p>
                    <span className="g-90 b3_2">{t('equipment_shipping22')}</span>
                  </div>
                </div>
                <div className="con_btm">
                  <p className="b1_1">{t('free_1')}</p>
                </div>
              </div>

              <div className="con_box">
                <div className="con_top">
                  <div className="flex-center-2 column">
                    <p className="p3">{t('equipment_arrival')}</p>
                    <span className="g-90 b3_2">{t('equipment_received')}</span>
                  </div>
                </div>
                <div className="con_btm">
                  <p className="b1_1">{t('free_1')}</p>
                </div>
              </div>

              <div className="con_box">
                <div className="con_top yell">
                  <div className="flex-center-2 column">
                    <p className="p3">{t('rental_1st_day', {day: 1})}</p>
                    <span className="g-90 b3_2">{t('equipment_rental_start_date')}</span>
                  </div>
                </div>
                <div className="con_btm">
                  <p className="b1_1 yell" style={{backgroundColor: '#F5C337'}}>{t('rental_fee_payment')}</p>
                </div>
              </div>

              <div className="con_box">
                <div className="con_top yell">
                  <div className="flex-center-2 column">
                    <p className="p3">{t('rental_1st_day', {day: 2})}</p>
                    <span className="g-90 b3_2">{t('equipment_rental_return_date')}</span>
                  </div>
                </div>
                <div className="con_btm">

                  <p className="b1_1 yell" style={{backgroundColor: '#F5C337'}}>{t('rental_fee_payment')}</p>
                </div>
              </div>

              <div className="con_box">
                <div className="con_top">
                  <div className="flex-center-2 column">
                    <p className="p3">{t('equipment_shipping22')}</p>
                    <span className="g-90 b3_2">{t('equipment_returned')}</span>
                  </div>
                </div>
                <div className="con_btm">
                  <p className="b1_1">{t('free_1')}</p>
                </div>
              </div>

              <div className="con_box">
                <div className="con_top">
                  <div className="flex-center-2 column">
                    <p className="p3">{t('equipment_shipping28')}</p>
                    <span className="g-90 b3_2">{t('equipment_returned')}</span>
                  </div>
                </div>
                <div className="con_btm">
                  <p className="b1_1">{t('free_1')}</p>
                </div>
              </div>
            </div>

            <div className="dash_list flex-2 column mt_16">
              <span className="guide_text_1 g-80">{t('delivery_order_2')}</span>
              <span className="guide_text_1 g-80">{t('delivery_order_2_1')}</span>
              <span className="guide_text_1 g-80">{t('12_hour_rental')}</span>
              <span className="guide_text_1 g-80">{t('24_hour_rental')}</span>
              <span className="guide_text_1 g-80">{t('cancel_reservation')}</span>
              <span className="guide_text_1 g-80">{t('submit_documents')}</span>
            </div>
          </div>
        </div>
      )}


      {/* 공통 */}
      <div>
        <div className="apply_guide mt_32 use_font">
          <h4>{t('rental_equipment_info')}</h4>
          <ul className="rental_list">
            <li>{t('equipment_function_familiarity')}</li>
            <li>{t('package_equipment')}</li>
            <li>{t('100%_reservation_system')}</li>
          </ul>
          <div className="dash_list flex-2 column">
            <span className="guide_text_1 g-80">{t('corporate_card_payment')}</span>
            <span className="guide_text_1 g-80">{t('12_hour_rental')}</span>
            <span className="guide_text_1 g-80">{t('24_hour_rental')}</span>
            <span className="guide_text_1 g-80">{t('cancel_reservation')}</span>
            <span className="guide_text_1 g-80">{t('submit_documents')}</span>
          </div>
        </div>

        <div className="apply_guide mt_32 use_font">
          <h4>{t('equipment_returned_info')}</h4>
          <ul className="rental_list">
            <li>{t('overtime_payment')}</li>
            <li>{t('100%_reservation_system_2')}</li>
            <li>{t('return_equipment2')}</li>
            <li>{t('equipment_defect')}</li>
          </ul>
        </div>

        <div className="reason_container">
          <h3 className="commu_title noline">{t('daypay_reason')}</h3>
          <div className="reason_inner">
            <ul className="reason_con">
              {instructionData.map((item, index) => (
                <li key={index}>
                  <img src={item.icon_image_url} alt="cart" loading="lazy"/>
                  <div className="reason_txt">
                    <p>{item.subject}</p>
                    <span className="g-90">
                      {item.content}
                  </span>
                </div>
                {item.btn_link_url && (
                <button
                  type="button"
                  className="reason_btn"
                  onClick={() => {
                    if (item.btn_link_url.startsWith('http')) {
                      window.open(item.btn_link_url, '_blank');
                    } else {
                      navigate(item.btn_link_url);
                    }
                  }}
                >
                  {item.btn_link_name}
                  </button>
                )}
                </li>
              ))}
            </ul>
          </div>
        </div>

      </div>

      <PopupLoginError
        isPopup={isPopupLoginError}
        setIsPopup={setIsPopupLoginError}
        onConfirm={handleConfirm}
      />

    </section>
  )
};

export default UsageInformation;
